import {Rol} from '../_rol/rol';
import {Certificado} from '../_certificado/certificado';
export class Usuario {
    id : number;    
    username : string;
    password : string;
    passwordAnterior : string;
    codigoMaestro : string;
    nombre : string;
    cargo : string;
    ejercicio : string;
    codigoDependencia : string;
    descDependendencia: string; 
    codigoCargo : string;
    descCargo: string; 
    codigoUnidadEjecutora : string;
    estado : string;
    usuarioRed : string;
    rolId : number;    
    rol : Rol;
    oficina: string;
    certificado: Certificado = new Certificado({claveArchivo: "", nombreArchivo: "", nombreArchivoFirma: ""});
    correoElectronico: string;
    tipoIdentif: string = 'T';

    constructor(json? : any) {
        if (json != null) {
            this.id = json.id;
            this.username = json.username;
            this.password = json.password;
            this.passwordAnterior = json.passwordAnterior;
            this.codigoMaestro = json.codigoMaestro;
            this.nombre = json.nombre;
            this.cargo = json.cargo;
            this.ejercicio = json.ejercicio;
            this.codigoDependencia = json.codigoDependencia;
            this.codigoUnidadEjecutora = json.codigoUnidadEjecutora;
            this.estado = json.estado;
            this.usuarioRed = json.usuarioRed;
            this.rolId = json.rolId;
            this.oficina = json.oficina;
            this.correoElectronico = json.correoElectronico;

            if (json.rol != null) {
                this.rol = new Rol(json.rol);
            }

            if (json.certificado != null) {
                this.certificado = new Certificado(json.certificado);
            }            
        }
    }

    // Utils
    static toArray(jsons : any[]) : Usuario[] {
        let usuarioList : Usuario[] = [];
        if (jsons != null) {
            for (let json of jsons) {
                usuarioList.push(new Usuario(json));
            }
        }
        return usuarioList;
    }

    static toFilter(usuarioSearch: Usuario) : Usuario {
        let usuarioFilter = new Usuario();
        if(usuarioSearch.ejercicio!=null && usuarioSearch.ejercicio!=""){
            usuarioFilter.ejercicio = usuarioSearch.ejercicio;
        }
            
        if(usuarioSearch.oficina!=null && usuarioSearch.oficina!=""){                
            usuarioFilter.oficina = usuarioSearch.oficina;
        }

        if(usuarioSearch.cargo!=null && usuarioSearch.cargo!=""){
            usuarioFilter.cargo = usuarioSearch.cargo;
        }

        if(usuarioSearch.username!=null && usuarioSearch.username!=""){
            usuarioFilter.username = usuarioSearch.username;
        }

        if(usuarioSearch.usuarioRed!=null && usuarioSearch.usuarioRed!=""){
            usuarioFilter.usuarioRed = usuarioSearch.usuarioRed;
        }

        if(usuarioSearch.rolId!=null && usuarioSearch.rolId != 0){
            usuarioFilter.rolId = usuarioSearch.rolId;
        }

        if(usuarioSearch.codigoUnidadEjecutora!=null && usuarioSearch.codigoUnidadEjecutora!=""){
            usuarioFilter.codigoUnidadEjecutora = usuarioSearch.codigoUnidadEjecutora;
        }

        if(usuarioSearch.codigoMaestro!=null && usuarioSearch.codigoMaestro!=""){
            usuarioFilter.codigoMaestro = usuarioSearch.codigoMaestro;
        }        

        if(usuarioSearch.nombre!=null && usuarioSearch.nombre!=""){
            usuarioFilter.nombre = usuarioSearch.nombre;
        } 

        return usuarioFilter;
    }

    static toFilter2(usuarioSearch: Usuario) : Usuario {
        let usuarioFilter = new Usuario();
        if(usuarioSearch.ejercicio!=null && usuarioSearch.ejercicio!=""){
            usuarioFilter.ejercicio = usuarioSearch.ejercicio;
        }

        if(usuarioSearch.oficina!=null && usuarioSearch.oficina!=""){
            usuarioFilter.oficina = usuarioSearch.oficina;
        }

        if(usuarioSearch.cargo!=null && usuarioSearch.cargo!=""){
            usuarioFilter.cargo = usuarioSearch.cargo;
        }

        if(usuarioSearch.username!=null && usuarioSearch.username!=""){
            usuarioFilter.username = usuarioSearch.username;
        }

        if(usuarioSearch.usuarioRed!=null && usuarioSearch.usuarioRed!=""){
            usuarioFilter.usuarioRed = usuarioSearch.usuarioRed;
        }

        if(usuarioSearch.rolId!=null && usuarioSearch.rolId != 0){
            usuarioFilter.rolId = usuarioSearch.rolId;
        }

        if(usuarioSearch.codigoUnidadEjecutora!=null && usuarioSearch.codigoUnidadEjecutora!=""){
            usuarioFilter.codigoUnidadEjecutora = usuarioSearch.codigoUnidadEjecutora;
        }

        if(usuarioSearch.codigoMaestro!=null && usuarioSearch.codigoMaestro!=""){
            usuarioFilter.codigoMaestro = usuarioSearch.codigoMaestro;
        }

        if(usuarioSearch.nombre!=null && usuarioSearch.nombre!=""){
            usuarioFilter.nombre = usuarioSearch.nombre;
        }

        if(usuarioSearch.codigoDependencia!=null && usuarioSearch.codigoDependencia!=""){
            usuarioFilter.codigoDependencia = usuarioSearch.codigoDependencia;
        }

        return usuarioFilter;
    }
}



// WEBPACK FOOTER //
// ./src/app/_seguridad/_usuario/usuario.ts